<style scoped>
.width-30 {
  width: 30%;
}
</style>

<template>
  <div>
    <div>
      <v-row>
        <v-col>
          <div class="d-flex">
            <span class="black--text heading">
              Team
            </span>
            <v-spacer />
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                icon
                small
                :disabled="!seniorFunder"
                v-bind="attrs"
                v-on="on"
                id="groups-edit-team-btn"
                @click="showEditModal"
                v-if-has-permission:hide="editSeniorFunderTeamPermission"
                >
                <v-icon>mdi-playlist-edit</v-icon>
              </v-btn>
            </template>
            <span>Edit Teams</span>
          </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <v-divider />
      <v-row v-if="loading">
        <v-col>
          <v-progress-linear
            v-if="loading"
            indeterminate
            color="black lighten-4"
            class="my-3"
          />
        </v-col>
      </v-row>
      <div v-else>
        <v-row v-if="seniorFunder && this.roles.length">
          <v-col v-for="role in roles" v-bind:key="role._id">
            <team-column-senior-funders
              :ref="role.title"
              :role="role"
              :seniorFunder="seniorFunder"
              v-model="groups[role._id]"
              @remove="showRemoveUserModal"
            />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col v-if="this.roles.length === 0">
            Roles are unavailable
          </v-col>
          <v-col v-else>
            Select a senior funder to view their processing team
          </v-col>
        </v-row>
      </div>
    </div>
    <admin-groups-edit-team-modal-senior-funders
      ref="editTeamModal"
      :seniorFunder="seniorFunder"
      :roles="roles"
      :groups="groups"
      @success="updateTeam"
    />
    <admin-groups-remove-user-modal-senior-funders
      ref="removeUserModal"
      :seniorFunder="seniorFunder"
      @success="updateRole"
    />
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import roleMixin from '@/mixins/roleMixin';
import TeamColumnSeniorFunders from './ColumnSeniorFunders';
import AdminGroupsEditTeamModalSeniorFunders from './modals/edit/ModalSeniorFunders';
import AdminGroupsRemoveUserModalSeniorFunders from './modals/RemoveUserModalSeniorFunders';


export default {
  name: 'AdminGroupsTeamSeniorFunders',
  mixins: [roleMixin],
  components: {
    TeamColumnSeniorFunders,
    AdminGroupsEditTeamModalSeniorFunders,
    AdminGroupsRemoveUserModalSeniorFunders,
  },
  props: {
    seniorFunder: Object,
  },
  data: () => ({
    roles: [],
    groups: {},
    loading: false,
    scores: { funder: 1 },
  }),
  computed: {
    editSeniorFunderTeamPermission: vm => vm.$permissions.EDIT_SENIOR_FUNDER_TEAM,
  },
  methods: {
    showEditModal() {
      this.$refs.editTeamModal.open();
    },
    showRemoveUserModal(role, user) {
      this.$refs.removeUserModal.open(role, user);
    },
    updateTeam(id) {
      const ref = this.roles.find(role => role._id === id).title;
      if (ref) {
        this.$refs[ref][0].fetch();
      }
    },
    fetch() {
      this.loading = true;
      this.roles = [];

      this.$requests.get('/v1/roles')
        .then(response => {
          const elegibleRoles = Object.keys(this.seniorFunderTitles);
          function filter(role) { return elegibleRoles.includes(role.title); }
          this.roles = response.data.filter(filter).sort((a, b) => (this.scores[a.title] - this.scores[b.title]));
        })
        .catch(() => {
          this.$toast.error('Unable to resolve roles...', { timeout: 3000 });
        })
        .then(() => { this.loading = false; });
    },
    updateRole(role) {
      this.$refs[role.title][0].fetch();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
